// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FormattedPrice-module-price-1QJjU{direction:ltr;display:inline-flex}s .FormattedPrice-module-price-1QJjU{text-decoration:line-through}", ""]);
// Exports
exports.locals = {
	"price": "FormattedPrice-module-price-1QJjU"
};
module.exports = exports;
